import React from "react";
import "./footer.scss"
import { Link } from "gatsby";
import Socials from "./socials";
import IconMmm from "../images/iconMmm";

const footerLinks1 = [
    { text: "Home", url: "/" },
    { text: "Collection", url: "/collection" },
    { text: "Prizes", url: "/prizes" },
    { text: "Crafting", url: "/crafting" },
    { text: "Merging", url: "/merging" },
    { text: "Staking", url: "/staking" },
  ]
const footerLinks2 = [
    { text: "FAQ", url: "/faq" },
    { text: "ERC-404", url: "/erc404" },
    { text: "MetFi", url: "/metfi" },
    { text: "MetBot", url: "/metbot" },
  ]

const Footer = () => {
    return <footer>
        <div className="socials row">
            <div className="col social-text">
                <IconMmm />
                Join the MetFi and Marine Moguls Community
            </div>
            <div className="col social-icons">
                <Socials />
            </div>
        </div>
        <div className="row footer-menu">
            <div className="col-1">
                <strong>Marine Moguls</strong><br />
                Dive into ownership, anchor your stakes, navigate the swaps, and sail through trades. Get hooked on the NFT that keeps you afloat in the sea of possibilities! <i>(Pun fully intended!)</i>
            </div>
            <div className="divider"></div>
            <div className="col-2" role="navigation" aria-label="footer 1">
                {footerLinks1.map((link) => (
                    <React.Fragment key={link.url}>
                        <Link activeClassName="active" to={link.url}>{link.text}</Link>
                    </React.Fragment>
                ))}
            </div>
            <div className="col-3" role="navigation" aria-label="footer 2">
                {footerLinks2.map((link) => (
                    <React.Fragment key={link.url}>
                        <Link activeClassName="active" to={link.url}>{link.text}</Link>
                    </React.Fragment>
                ))}
                <hr />
                <a href="https://airdrop.marinemoguls.com">Airdrop</a>
                <Link to="/claims" activeClassName="active">Claims</Link>
            </div>
        </div>
    </footer>
}

export default Footer